export default __webpack_public_path__ + "static/media/les_download.9bc84ae8.svg";